import { log, supabase } from ".";

export const saveCliente = async (cliente) => {
  try {
    const data = await supabase.insertReturning("clientes", cliente);

    if (!data || (Array.isArray(data) && data.length === 0)) throw new Error("Empty response");

    // Sincronizar contactos a tablas relacionales (fuente de la verdad)
    const newId = Array.isArray(data) ? data[0]?.id : data?.id;
    if (newId) {
      // Agencia: contacto_agencia → Director
      if (cliente.contacto_agencia) {
        try {
          await supabase.insert("clientes_contactos_agencia", {
            cliente_id: newId,
            usuario_id: cliente.contacto_agencia,
            cargo: "Director",
          });
        } catch (e) {
          log.error("saveCliente: sync CCA", e);
        }
      }
      // Cliente: contacto_cliente → Gerente de Marketing
      if (cliente.contacto_cliente) {
        try {
          await supabase.insert("clientes_contactos_cliente", {
            cliente_id: newId,
            usuario_id: cliente.contacto_cliente,
            cargo: "Gerente de Marketing",
          });
        } catch (e) {
          log.error("saveCliente: sync CCC", e);
        }
      }
    }

    return data;
  } catch (error) {
    log.error("saveCliente", error);
    throw error;
  }
};
